<template>
  <div @click="showPhotos('my-media-photo',item)" class="cursor-pointer">
    <div class="h-40 lg:h-44 relative justify-self-stretch">
      <div  class="inset-0 rounded-xl overflow-hidden shadow-item group h-full w-full">
        <img v-if="!includesVideo" :onerror="`this.onerror=null; this.src='${IMAGE_PLACEHOLDER}'`" :src="item.thumbnail_url" :alt="item.name" loading="lazy" class="absolute h-full w-full object-cover rounded-xl"/>
        <video
          ref="video"
          v-else
          class="w-full h-full object-cover rounded-item"
          @mouseleave="stop($event)"
          @mouseenter="play($event)"
          muted
          loop
        >
          <source :src="item.thumbnail_url" :type="item.mime_type && item.mime_type !== 'video/quicktime' ? item.mime_type : 'video/mp4'">
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
    <div class="flex items-center justify-between pt-3">
        <h4 class="font-semibold w-32 2xl:text-lg truncate" :title="item.name">{{ item.name }}</h4>
    </div>
  </div>
</template>
<script>
import { IMAGE_PLACEHOLDER } from '@/utils/constants';

export default {
  name: 'PostMyMediaItem',

  props: {
    item:{
      type:Object,
      require:true
    } ,
  },

  data() {
    return {
      IMAGE_PLACEHOLDER
    }
  },

  computed: {
    includesVideo() {
      return this.item && this.item.mime_type.includes('video');
    },
  },

  methods: {
    showPhotos(show, item){
      this.$emit('clicked', {'show': show, 'item':item});
    },

    play(event) {
      event.target.play();
    },
    stop(event) {
      event.target.pause();
    },
  }
}
</script>